/* eslint-disable no-template-curly-in-string */
const AG_GRID_LOCALE_RU = {
  // Set Filter
  selectAll: "(Выбрать все)",
  selectAllSearchResults: "(Выбрать все)",
  addCurrentSelectionToFilter: "Добавить текущий выбор в фильтр",
  searchOoo: "Поиск...",
  blanks: "(Пусто)",
  noMatches: "Нет совпадений",

  // Number Filter & Text Filter
  filterOoo: "Фильтр...",
  equals: "Равно",
  notEqual: "Не равно",
  blank: "Пустой",
  notBlank: "Не пустой",
  empty: "Выбери один",

  // Number Filter
  lessThan: "Меньше чем",
  greaterThan: "Больше чем",
  lessThanOrEqual: "Меньше или равно",
  greaterThanOrEqual: "Больше или равно",
  inRange: "Между",
  inRangeStart: "От",
  inRangeEnd: "До",

  // Text Filter
  contains: "Содержит",
  notContains: "Не содержит",
  startsWith: "Начинается с",
  endsWith: "Заканчивается на",

  // Date Filter
  dateFormatOoo: "yyyy-mm-dd",
  before: "До",
  after: "После",

  // Filter Conditions
  andCondition: "И",
  orCondition: "ИЛИ",

  // Filter Buttons
  applyFilter: "Применить",
  resetFilter: "Сбросить",
  clearFilter: "Очистить",
  cancelFilter: "Отмена",

  // Filter Titles
  textFilter: "Текстовый фильтр",
  numberFilter: "Числовой фильтр",
  dateFilter: "Фильтр даты",
  setFilter: "Фильтр выбора",

  // Group Column Filter
  groupFilterSelect: "Выберите поле:",

  // Advanced Filter
  advancedFilterContains: "содержит",
  advancedFilterNotContains: "не содержит",
  advancedFilterTextEquals: "равно",
  advancedFilterTextNotEqual: "не равно",
  advancedFilterStartsWith: "начинается с",
  advancedFilterEndsWith: "заканчивается",
  advancedFilterBlank: "пусто",
  advancedFilterNotBlank: "не пусто",
  advancedFilterEquals: "=",
  advancedFilterNotEqual: "!=",
  advancedFilterGreaterThan: ">",
  advancedFilterGreaterThanOrEqual: ">=",
  advancedFilterLessThan: "<",
  advancedFilterLessThanOrEqual: "<=",
  advancedFilterTrue: "истина",
  advancedFilterFalse: "ложь",
  advancedFilterAnd: "И",
  advancedFilterOr: "ИЛИ",
  advancedFilterApply: "Применить",
  advancedFilterBuilder: "Строитель",
  advancedFilterValidationMissingColumn: "Столбец отсутствует",
  advancedFilterValidationMissingOption: "Опция отсутствует",
  advancedFilterValidationMissingValue: "Значение отсутствует",
  advancedFilterValidationInvalidColumn: "Столбец не найден",
  advancedFilterValidationInvalidOption: "Вариант не найден",
  advancedFilterValidationMissingQuote: "В значении отсутствует конечная кавычка",
  advancedFilterValidationNotANumber: "Значение не является числом",
  advancedFilterValidationInvalidDate: "Значение не является допустимой датой",
  advancedFilterValidationMissingCondition: "Условие отсутствует",
  advancedFilterValidationJoinOperatorMismatch: "Операторы объединения внутри условия должны быть одинаковыми",
  advancedFilterValidationInvalidJoinOperator: "Оператор объединения не найден",
  advancedFilterValidationMissingEndBracket: "Отсутствует концевая скоба",
  advancedFilterValidationExtraEndBracket: "Слишком много концевых скобок",
  advancedFilterValidationMessage: "В выражении есть ошибка. ${variable} - ${variable}.",
  advancedFilterValidationMessageAtEnd: "В выражении есть ошибка. ${variable} в конце выражения.",
  advancedFilterBuilderTitle: "Расширенный фильтр",
  advancedFilterBuilderApply: "Применять",
  advancedFilterBuilderCancel: "Отмена",
  advancedFilterBuilderAddButtonTooltip: "Добавить фильтр или группу",
  advancedFilterBuilderRemoveButtonTooltip: "Удалять",
  advancedFilterBuilderMoveUpButtonTooltip: "Переместить вверх",
  advancedFilterBuilderMoveDownButtonTooltip: "Переместить Вниз",
  advancedFilterBuilderAddJoin: "Добавить группу",
  advancedFilterBuilderAddCondition: "Добавить фильтр",
  advancedFilterBuilderSelectColumn: "Выберите столбец",
  advancedFilterBuilderSelectOption: "Выберите вариант",
  advancedFilterBuilderEnterValue: "Введите значение...",
  advancedFilterBuilderValidationAlreadyApplied: "Текущий фильтр уже применен.",
  advancedFilterBuilderValidationIncomplete: "Не все условия выполнены.",
  advancedFilterBuilderValidationSelectColumn: "Необходимо выбрать столбец.",
  advancedFilterBuilderValidationSelectOption: "Необходимо выбрать вариант.",
  advancedFilterBuilderValidationEnterValue: "Необходимо ввести значение.",

  // Side Bar
  columns: "Столбцы",
  filters: "Фильтры",

  // columns tool panel
  pivotMode: "Pivot Mode",
  groups: "Группы строк",
  rowGroupColumnsEmptyMessage: "Перетащите сюда, чтобы установить группы строк",
  values: "Значения",
  valueColumnsEmptyMessage: "Перетащите сюда, чтобы агрегировать",
  pivots: "Метки столбцов",
  pivotColumnsEmptyMessage: "Перетащите сюда, чтобы установить метки столбцов",

  // Header of the Default Group Column
  group: "Группа",

  // Row Drag
  rowDragRow: "строка",
  rowDragRows: "строки",

  // Other
  loadingOoo: "Загрузка...",
  loadingError: "ERR",
  noRowsToShow: "Нет строк для отображения",
  enabled: "Включено",

  // Menu
  pinColumn: "Закрепить столбец",
  pinLeft: "Закрепить слева",
  pinRight: "Закрепить справа",
  noPin: "Не закреплять",
  valueAggregation: "Агрегация значений",
  noAggregation: "Ничего",
  autosizeThiscolumn: "Авторазмер этого столбца",
  autosizeAllColumns: "Авторазмер всех столбцов",
  groupBy: "Группировать по",
  ungroupBy: "Разгруппировать по",
  ungroupAll: "Разгруппировать все",
  addToValues: "Добавить ${variable} к значениям",
  removeFromValues: "Удалить ${variable} из значений",
  addToLabels: "Добавить ${variable} к меткам",
  removeFromLabels: "Удалить ${variable} из меток",
  resetColumns: "Сбросить столбцы",
  expandAll: "Развернуть все группы строк",
  collapseAll: "Закрыть все группы строк",
  copy: "Копировать",
  ctrlC: "Ctrl+C",
  ctrlX: "Ctrl+X",
  copyWithHeaders: "Копировать с заголовками",
  copyWithGroupHeaders: "Копировать с заголовками групп",
  cut: "Вырезать",
  paste: "Вставить",
  ctrlV: "Ctrl+V",
  export: "Экспорт",
  csvExport: "CSV Экспорт",
  excelExport: "Excel Экспорт",
  columnFilter: "Фильтр столбца",
  columnChooser: "Выберите столбцы",
  sortAscending: "Сортировать по возрастанию",
  sortDescending: "Сортировать по убыванию",
  sortUnSort: "Очистить сортировку",

  // Enterprise Menu Aggregation and Status Bar
  sum: "Сумма",
  first: "Первый",
  last: "Последний",
  min: "Мин",
  max: "Макс",
  none: "None",
  count: "Число",
  avg: "Среднее",
  filteredRows: "Отфильтровано",
  selectedRows: "Выбрано",
  totalRows: "Всего строк",
  totalAndFilteredRows: "Строки",
  more: "Больше",
  to: "к",
  of: "от",
  page: "Страница",
  pageLastRowUnknown: "?",
  nextPage: "Следущая страница",
  lastPage: "Последняя страница",
  firstPage: "Первая страница",
  previousPage: "Предыдущая страница",
  pageSizeSelectorLabel: "Размер страницы:",
  footerTotal: "Всего",

  // Pivoting
  pivotColumnGroupTotals: "Всего",

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: "Pivot Chart & Pivot Mode",
  pivotChart: "Сводная диаграмма",
  chartRange: "Диапазон диаграммы",

  columnChart: "Column",
  groupedColumn: "Grouped",
  stackedColumn: "Stacked",
  normalizedColumn: "100% Stacked",

  barChart: "Bar",
  groupedBar: "Grouped",
  stackedBar: "Stacked",
  normalizedBar: "100% Stacked",

  pieChart: "Pie",
  pie: "Pie",
  donut: "Donut",

  line: "Line",

  xyChart: "X Y (Scatter)",
  scatter: "Scatter",
  bubble: "Bubble",

  areaChart: "Area",
  area: "Area",
  stackedArea: "Stacked",
  normalizedArea: "100% Stacked",

  histogramChart: "Histogram",
  histogramFrequency: "Frequency",

  polarChart: "Polar",
  radarLine: "Radar Line",
  radarArea: "Radar Area",
  nightingale: "Nightingale",
  radialColumn: "Radial Column",
  radialBar: "Radial Bar",

  statisticalChart: "Statistical",
  boxPlot: "Box Plot",
  rangeBar: "Range Bar",
  rangeArea: "Range Area",

  hierarchicalChart: "Hierarchical",
  treemap: "Treemap",
  sunburst: "Sunburst",

  specializedChart: "Specialized",
  waterfall: "Waterfall",
  heatmap: "Heatmap",

  combinationChart: "Combination",
  columnLineCombo: "Column & Line",
  AreaColumnCombo: "Area & Column",

  // Charts
  pivotChartTitle: "Сводная диаграмма",
  rangeChartTitle: "Диаграмма диапазонов",
  settings: "Настройки",
  data: "Данные",
  format: "Формат",
  categories: "Категории",
  defaultCategory: "(Ничего)",
  series: "Ряды",
  xyValues: "X Y Значения",
  paired: "Paired Mode",
  axis: "Axis",
  radiusAxis: "Radius Axis",
  navigator: "Навигатор",
  color: "Цвет",
  thickness: "Толщина",
  preferredLength: "Предпочтительная длина",
  xType: "X Тип",
  automatic: "Автоматический",
  category: "Категория",
  number: "Число",
  time: "Время",
  autoRotate: "Авто-поворот",
  xRotation: "X Поворот",
  yRotation: "Y Поворот",
  labelRotation: "Поворот",
  circle: "Круг",
  polygon: "Полигон",
  orientation: "Ориентация",
  fixed: "Зафиксированно",
  parallel: "Параллельно",
  perpendicular: "Перпендикулярно",
  radiusAxisPosition: "Позиция",
  ticks: "Ticks",
  width: "Ширина",
  height: "Высота",
  length: "Длина",
  padding: "Отступы",
  spacing: "Пространство",
  chart: "Диаграмма",
  title: "Заголовок",
  titlePlaceholder: "Название диаграммы — дважды щелкните, чтобы изменить",
  background: "Фон",
  font: "Шрифт",
  top: "Вверх",
  right: "Вправо",
  bottom: "Вниз",
  left: "Влево",
  labels: "Метки",
  calloutLabels: "Ярлыки выносок",
  sectorLabels: "Метки секторов",
  positionRatio: "Коэффициент позиции",
  size: "Размер",
  shape: "Форма",
  minSize: "Минимальный размер",
  maxSize: "Максимальный размер",
  legend: "Легенда",
  position: "Позиция",
  markerSize: "Размер маркера",
  markerStroke: "Обводка маркера",
  markerPadding: "Отступы маркера",
  itemSpacing: "Расстояние между элементами",
  itemPaddingX: "Отступ элемента X",
  itemPaddingY: "Отступ элемента Y",
  layoutHorizontalSpacing: "Горизонтальный интервал",
  layoutVerticalSpacing: "Вертикальный интервал",
  strokeWidth: "Ширина обводки",
  offset: "Смещение",
  offsets: "Смещения",
  tooltips: "Подсказки",
  callout: "Вызовы",
  markers: "Маркеры",
  shadow: "Тень",
  blur: "Размытие",
  xOffset: "X Смещение",
  yOffset: "Y Смещение",
  lineWidth: "Ширина линии",
  lineDash: "Штрихи линии",
  lineDashOffset: "Смещение штриха",
  normal: "Нормальный",
  bold: "Жирный",
  italic: "Курсив",
  boldItalic: "Жирный курсив",
  predefined: "Предопределенный",
  fillOpacity: "Заполнитель прозрачности",
  strokeColor: "Цвет линии",
  strokeOpacity: "Прозрачность линии",
  histogramBinCount: "Bin count",
  connectorLine: "Соединительная линия",
  seriesItems: "Серия значений",
  seriesItemType: "Тип значений",
  seriesItemPositive: "Положительный",
  seriesItemNegative: "Отрицательный",
  seriesItemLabels: "Метки значений",
  columnGroup: "Столбец",
  barGroup: "Bar",
  pieGroup: "Pie",
  lineGroup: "Line",
  scatterGroup: "X Y (Scatter)",
  areaGroup: "Area",
  polarGroup: "Polar",
  statisticalGroup: "Статистический",
  hierarchicalGroup: "Иерархический",
  specializedGroup: "Специализированный",
  combinationGroup: "Комбинированный",
  groupedColumnTooltip: "Сгруппировано",
  stackedColumnTooltip: "Stacked",
  normalizedColumnTooltip: "100% Stacked",
  groupedBarTooltip: "Сгруппировано",
  stackedBarTooltip: "Сложенный",
  normalizedBarTooltip: "100% Сложенный",
  pieTooltip: "Pie",
  donutTooltip: "Donut",
  lineTooltip: "Line",
  groupedAreaTooltip: "Область",
  stackedAreaTooltip: "Сложенный",
  normalizedAreaTooltip: "100% Сложенный",
  scatterTooltip: "Scatter",
  bubbleTooltip: "Bubble",
  histogramTooltip: "Histogram",
  radialColumnTooltip: "Radial Column",
  radialBarTooltip: "Radial Bar",
  radarLineTooltip: "Radar Line",
  radarAreaTooltip: "Radar Area",
  nightingaleTooltip: "Nightingale",
  rangeBarTooltip: "Range Bar",
  rangeAreaTooltip: "Range Area",
  boxPlotTooltip: "Box Plot",
  treemapTooltip: "Treemap",
  sunburstTooltip: "Sunburst",
  waterfallTooltip: "Waterfall",
  heatmapTooltip: "Heatmap",
  columnLineComboTooltip: "Столбец и линия",
  areaColumnComboTooltip: "Площадь и столбец",
  customComboTooltip: "Пользовательская комбинация",
  innerRadius: "Внутренний радиус",
  startAngle: "Начальный угол",
  endAngle: "Конечный угол",
  reverseDirection: "Обратное направление",
  groupPadding: "Отступы группы",
  seriesPadding: "Отступы рядов",
  tile: "Tile",
  whisker: "Whisker",
  cap: "Cap",
  capLengthRatio: "Соотношение длины",
  labelPlacement: "Размещение",
  inside: "Внутри",
  outside: "Снаружи",
  noDataToChart: "Нет данных для построения диаграммы.",
  pivotChartRequiresPivotMode: "Для сводной диаграммы требуется включить режим сводной таблицы.",
  chartSettingsToolbarTooltip: "Меню",
  chartLinkToolbarTooltip: "Связанно с Grid",
  chartUnlinkToolbarTooltip: "Отвязанно от Grid",
  chartDownloadToolbarTooltip: "Скачать диаграмму",
  seriesChartType: "Тип рядов диаграммы",
  seriesType: "Тип рядов",
  secondaryAxis: "Вторичная ось",

  // ARIA
  ariaAdvancedFilterBuilderItem: "${variable}. Уровень ${variable}. Нажмите ENTER, чтобы редактировать.",
  ariaAdvancedFilterBuilderItemValidation: "${variable}. Уровень ${variable}. ${variable} Нажмите ENTER, чтобы редактировать.",
  ariaAdvancedFilterBuilderList: "Расширенный список построителей фильтров",
  ariaAdvancedFilterBuilderFilterItem: "Состояние фильтра",
  ariaAdvancedFilterBuilderGroupItem: "Группа фильтров",
  ariaAdvancedFilterBuilderColumn: "Столбец",
  ariaAdvancedFilterBuilderOption: "Варианты",
  ariaAdvancedFilterBuilderValueP: "Значений",
  ariaAdvancedFilterBuilderJoinOperator: "Добавить оператор",
  ariaAdvancedFilterInput: "Расширенный фильтр ввода",
  ariaChecked: "checked",
  ariaColumn: "Столбец",
  ariaColumnGroup: "Группа столбцов",
  ariaColumnFiltered: "Фильтр столбцов",
  ariaColumnSelectAll: "Переключить выбор всех столбцов",
  ariaDateFilterInput: "Фильтр даты Input",
  ariaDefaultListName: "List",
  ariaFilterColumnsInput: "Фильтр столбцов Input",
  ariaFilterFromValue: "Фильтр по значению",
  ariaFilterInput: "Ввод фильтра",
  ariaFilterList: "Список фильтров",
  ariaFilterToValue: "Фильтровать по значению",
  ariaFilterValue: "Значение фильтра",
  ariaFilterMenuOpen: "Открыть меню фильтров",
  ariaFilteringOperator: "Оператор фильтрации",
  ariaHidden: "скрытый",
  ariaIndeterminate: "неопределенный",
  ariaInputEditor: "Редактор ввода",
  ariaMenuColumn: "Нажмите ALT DOWN, чтобы открыть меню столбца",
  ariaFilterColumn: "Нажмите CTRL ENTER, чтобы открыть фильтр",
  ariaRowDeselect: "Нажмите ПРОБЕЛ, чтобы отменить выбор этой строки",
  ariaRowSelectAll: "Нажмите пробел, чтобы переключить выбор всех строк",
  ariaRowToggleSelection: "Нажмите пробел, чтобы переключить выбор строки",
  ariaRowSelect: "Нажмите ПРОБЕЛ, чтобы выбрать эту строку",
  ariaSearch: "Поиск",
  ariaSortableColumn: "Нажмите ENTER, чтобы отсортировать",
  ariaToggleVisibility: "Нажмите ПРОБЕЛ, чтобы переключить видимость",
  ariaToggleCellValue: "Нажмите ПРОБЕЛ, чтобы переключить значение ячейки",
  ariaUnchecked: "unchecked",
  ariaVisible: "видимый",
  ariaSearchFilterValues: "Значения фильтра поиска",
  ariaPageSizeSelectorLabel: "Размер страницы",

  // ARIA Labels for Drop Zones
  ariaRowGroupDropZonePanelLabel: "Группы строк",
  ariaValuesDropZonePanelLabel: "Значения",
  ariaPivotDropZonePanelLabel: "Метки столбцов",
  ariaDropZoneColumnComponentDescription: "Нажмите DELETE, чтобы удалить",
  ariaDropZoneColumnValueItemDescription: "Нажмите ENTER, чтобы изменить тип агрегации",
  ariaDropZoneColumnGroupItemDescription: "Нажмите ENTER, чтобы отсортировать",
  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
  ariaDropZoneColumnComponentAggFuncSeparator: " от ",
  ariaDropZoneColumnComponentSortAscending: "восходящий",
  ariaDropZoneColumnComponentSortDescending: "нисходящий",

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: "Меню столбца",
  ariaLabelColumnFilter: "Фильтр столбца",
  ariaLabelCellEditor: "Редактор ячеек",
  ariaLabelDialog: "Диалог",
  ariaLabelSelectField: "Выберите поле",
  ariaLabelRichSelectField: "Расширенное поле выбора",
  ariaLabelTooltip: "Подсказка",
  ariaLabelContextMenu: "Контекстное меню",
  ariaLabelSubMenu: "Подменю",
  ariaLabelAggregationFunction: "Функции агрегирования",
  ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
  ariaLabelAdvancedFilterBuilderAddField: "Advanced Filter Builder Add Field",
  ariaLabelAdvancedFilterBuilderColumnSelectField: "Advanced Filter Builder Column Select Field",
  ariaLabelAdvancedFilterBuilderOptionSelectField: "Advanced Filter Builder Option Select Field",
  ariaLabelAdvancedFilterBuilderJoinSelectField: "Advanced Filter Builder Join Operator Select Field",

  // ARIA Labels for the Side Bar
  ariaColumnPanelList: "Список столбцов",
  ariaFilterPanelList: "Список фильтров",

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ",",
  decimalSeparator: ".",

  // Data types
  true: "Истина",
  false: "Ложь",
  invalidDate: "Некорректная дата",
  invalidNumber: "Некорректное число",
  january: "Январь",
  february: "Февраль",
  march: "Март",
  april: "Апрель",
  may: "Май",
  june: "Июнь",
  july: "Июль",
  august: "Август",
  september: "Сентябрь",
  october: "Октябрь",
  november: "Ноябрь",
  december: "Декабрь"
};

export default AG_GRID_LOCALE_RU;
